export default "__VITE_ASSET__pQexpqFt__"